import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UtilService } from '@services';

import {
  fetchServiceProviders,
  selectServiceProviders,
  selectServiceProvidersFetchedAt,
} from '@state';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './service-providers.page.html',
  styleUrl: './service-providers.page.scss',
})
export class ServiceProvidersPage implements OnInit {
  columns: string[] = ['image', 'name', 'status'];

  $serviceProvidersFetchedAt = this.store.select(selectServiceProvidersFetchedAt);
  $serviceProviders = this.store.select(selectServiceProviders);

  constructor(
    private store: Store,
    private router: Router,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchServiceProviders());
  }

  public onRowClicked(id: string): void {
    this.router.navigate([`/service-providers/${id}`]);
  }
}
